import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ className = "" }) => (
  <Link to="/" data-testid="logo-link" className={`flex items-center gap-3 ${className}`}>
    <img
      src="/logo-lumina.png"
      alt="Lumina Africa — monogramme LA"
      data-testid="logo-monogram"
      className="h-9 w-9 object-contain select-none"
      draggable="false"
    />
    <span className="flex items-baseline gap-2">
      <span className="font-serif-lux text-2xl tracking-[0.15em] text-white">LUMINA</span>
      <span className="flex items-center gap-2">
        <span className="h-px w-4 bg-[#d4af37]/60" />
        <span className="text-[0.65rem] tracking-[0.4em] text-[#d4af37] uppercase">Africa</span>
      </span>
    </span>
  </Link>
);
